import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';

@Component({
  selector: 'app-transaction-report-agent',
  templateUrl: './transaction-report-agent.component.html',
  styleUrl: './transaction-report-agent.component.css'
})
export class TransactionReportAgentComponent implements OnInit {
  agents = [];
  loadingData: boolean = false;
  breadCrumb: any;
  constructor(private userService: UserService){}
  ngOnInit():void{
    this.breadCrumb  = {
      name: 'Transaction Agent Report',
      parent: 'Reports',
      subLink: null
    };
    this.getAgentReportCollection()
  }
  getAgentReportCollection (){
    this.loadingData = true;
    return this.userService.getAgentReport().subscribe({
      next: (response)=>{
        this.agents = response;
      }
    }).add(()=> this.loadingData = false)
  }
  
}
